export const EARLY_GRADE_MOVER_EMAILS = new Set([
  'julian.hernandez@alpha.school'
]);

export const EARLY_GRADE_TRACKS = {
  '-1': [
    'TRACK_PREK_NAMING',
    'TRACK_PREK_SUBITIZING',
    'TRACK_PREK_COUNTING',
    'TRACK_PREK_WHATCOMESNEXT'
  ],
  '0': [
    'TRACK_K_NAMING',
    'TRACK_K_SUBITIZING',
    'TRACK_K_COMPARING',
    'TRACK_K_PARTWHOLE',
    'TRACK_K_ADDITION_WITHIN_5',
    'TRACK_K_ACCURACY',
    'TRACK13'
  ]
} as const;

export type EarlyGrade = keyof typeof EARLY_GRADE_TRACKS;

export function canUseEarlyGradeMove(email: string | undefined, role?: 'admin' | 'student'): boolean {
  return role === 'admin' || (!!email && EARLY_GRADE_MOVER_EMAILS.has(email.trim().toLowerCase()));
}
